
// Scroll to Top when refresh page
/*window.addEventListener('beforeunload', function load() {
    window.scrollTo(0, 0);
},false);*/

// Scroll to Top when refresh page - Disable scroll history
history.scrollRestoration = "manual";

// Remove markup for fallback version
window.addEventListener('load', function load() {

    window.removeEventListener('load', load, false);
    document.body.classList.remove('preload');

},false);
